<script lang="ts">
  import { onMount } from "svelte"
  import { xhr, toast } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  let errors: any = $state({})
  interface Props {
    goal: GoalType
    onduplicated: (goal: GoalType) => void
  }

  let { goal, onduplicated }: Props = $props()

  const dates = appStore.dates
  const channel_id = appStore.channel_id

  let form = $state({
    ...goal,
    name: `${goal.name}`,
    id: null,
    status: "on_track",
    parent_goal_id: goal.parent_goal_id,
    expected_at: dates.next_year_end
  })

  let subGoals: GoalType[] = $state([])
  let selectedSubGoals: GoalType[] = $state([])
  let goal_ids: number[] = $state([])

  subGoals = appStore.goals.filter((g) => g.parent_goal_id === goal.id)

  let goalTasks: TaskType[] = $state([])
  let selectedGoalTasks: TaskType[] = $state([])

  goalTasks = appStore.tasks.filter((t) => goal_ids.includes(t.goal_id))

  onMount(() => {
    selectedSubGoals = subGoals.filter((g) => g._selected)
    goal_ids = subGoals.map((g) => g.id)
    selectedGoalTasks = goalTasks.filter((t) => t._selected)
  })

  function getData(): any[] {
    return appStore.goals
      .filter((g) => g.parent_goal_id === goal.id && g._selected)
      .map((g) => {
        return {
          id: g.id,
          task_ids: appStore.tasks
            .filter((t) => t.goal_id === g.id && t._selected)
            .map((t) => t.id)
        }
      })
  }

  /**
   * Unselect all goals when completed the duplication
   */
  function resetGoal(): void {
    const subGoals = appStore.goals.filter((g) => g.parent_goal_id === goal.id)
    subGoals.forEach((g) => {
      g._selected = false
      g.toggle = false
    })
    const goal_ids = subGoals.map((g) => g.id)
    appStore.tasks
      .filter((t) => goal_ids.includes(t.goal_id))
      .forEach((t) => (t._selected = false))
  }

  let saving = $state(false)
  async function duplicateGoal(): Promise<void> {
    saving = true

    try {
      const resp = await xhr.post(
        `/plans/${goal.plan_id}/annual_goals/duplicate`,
        {
          id: goal.id,
          channel: channel_id,
          goal: {
            ...form,
            subgoals: getData()
          }
        }
      )

      onduplicated(resp.data)
      resetGoal()
    } catch (e: any) {
      toast("There was an error duplicating the goal", "error")
      errors = e.response.data.errors
    } finally {
      saving = false
    }
  }

  const longTermGoals = appStore.goals.filter((g) => g.type === "LongTermGoal")

  function selectSubGoals(sel: boolean): void {
    appStore.goals
      .filter((g) => g.parent_goal_id === goal.id)
      .forEach((goal) => (goal._selected = sel))

    appStore.goals = appStore.goals
  }

  function selectTasks(sel: boolean): void {
    goalTasks
      .filter((t) => goal_ids.includes(t.goal_id))
      .forEach((t) => (t._selected = sel))

    appStore.tasks = appStore.tasks
  }
</script>

<div style="min-width:400px">
  <div>
    <h2 class="text-xl text-gray-500">
      Duplicate Annual Goal to
      <span class="font-semibold">{dates.next_quarter}</span>
    </h2>

    <div>
      <label class="mb-1" for="name">Name</label>
      <div class="input-cont" class:error={errors.name}>
        <input
          type="text"
          data-name="goal-name"
          bind:value={form.name}
          class="input pt-2 pb-3"
        />
        <div class="msg">{errors.name}</div>
      </div>
    </div>

    <div>
      <label for="">Parent goal</label>
      <div class="input-cont">
        <select name="" id="" bind:value={form.parent_goal_id}>
          {#each longTermGoals as ltg (ltg.id)}
            <option value={ltg.id}>{ltg.name}</option>
          {/each}
        </select>
      </div>
    </div>

    <div class="py-4 font-semibold text-gray-500">
      <div>
        Selected {selectedSubGoals.length} child goals of {subGoals.length}
        {#if selectedSubGoals.length !== subGoals.length}
          <button
            class="text-blue-500 text-sm"
            type="button"
            onclick={() => selectSubGoals(true)}
          >
            Select child goals
          </button>
        {/if}
      </div>
      <div>
        Selected {selectedGoalTasks.length} tasks of {goalTasks.length}.
        {#if selectedGoalTasks.length !== goalTasks.length}
          <button
            class="text-blue-500 text-sm"
            type="button"
            onclick={() => selectTasks(true)}
          >
            Select sub tasks
          </button>
        {/if}
      </div>
    </div>
  </div>

  <div class="text-center md:text-right">
    <button
      class="btn-rounded success btn-big w-full h-12"
      disabled={saving}
      onclick={duplicateGoal}
    >
      Duplicate
    </button>
  </div>
</div>
